enum UserInfoFormEnum {
    LoggedIn = "logged-in",
    Check = "check",
    Login = "login",
    Register = "register",
    Edit = "edit",
    Reset = "reset",
    None = "",
}

export default UserInfoFormEnum